export const DEFAULT_LEAD_STATUSES = [
  { value: "yeni", label: "Yeni", tone: "violet" },
  { value: "iletisim", label: "İletişimde", tone: "blue" },
  { value: "teklif", label: "Teklif Verildi", tone: "amber" },
  { value: "takip", label: "Takip", tone: "blue" },
  { value: "kazanildi", label: "Kazanıldı", tone: "emerald" },
  { value: "kaybedildi", label: "Kaybedildi", tone: "rose" },
];

export const DEFAULT_LEAD_SOURCES = [
  { value: "direkt", label: "Direkt" },
  { value: "whatsapp", label: "Whatsapp" },
  { value: "instagram", label: "Instagram" },
  { value: "facebook", label: "Facebook" },
  { value: "web", label: "Web Sitesi" },
  { value: "telefon", label: "Telefon" },
];

export const LEAD_TONE_CLASSES = {
  violet: { dark: "bg-violet-500/20 text-violet-300 border-violet-500/30 ring-violet-500/20", light: "bg-violet-100 text-violet-700 border-violet-200 ring-violet-100" },
  blue: { dark: "bg-blue-500/20 text-blue-300 border-blue-500/30 ring-blue-500/20", light: "bg-blue-100 text-blue-700 border-blue-200 ring-blue-100" },
  amber: { dark: "bg-amber-500/20 text-amber-300 border-amber-500/30 ring-amber-500/20", light: "bg-amber-100 text-amber-800 border-amber-200 ring-amber-100" },
  emerald: { dark: "bg-emerald-500/20 text-emerald-300 border-emerald-500/30 ring-emerald-500/20", light: "bg-emerald-100 text-emerald-700 border-emerald-200 ring-emerald-100" },
  rose: { dark: "bg-rose-500/20 text-rose-300 border-rose-500/30 ring-rose-500/20", light: "bg-rose-100 text-rose-700 border-rose-200 ring-rose-100" },
  cyan: { dark: "bg-cyan-500/20 text-cyan-300 border-cyan-500/30 ring-cyan-500/20", light: "bg-cyan-100 text-cyan-700 border-cyan-200 ring-cyan-100" },
};

export const LEAD_TONE_DOT = {
  violet: "bg-violet-400",
  blue: "bg-blue-400",
  amber: "bg-amber-400",
  emerald: "bg-emerald-400",
  rose: "bg-rose-400",
  cyan: "bg-cyan-400",
};

export const LEAD_TONE_RING = {
  violet: "ring-violet-500/60",
  blue: "ring-blue-500/60",
  amber: "ring-amber-500/60",
  emerald: "ring-emerald-500/60",
  rose: "ring-rose-500/60",
  cyan: "ring-cyan-500/60",
};

export const getLeadSourceMeta = (value, leadSources = DEFAULT_LEAD_SOURCES) =>
  leadSources.find((s) => s.value === value);

export const getLeadStatusMeta = (status, leadStatuses = DEFAULT_LEAD_STATUSES) =>
  leadStatuses.find((s) => s.value === status) || leadStatuses[0] || DEFAULT_LEAD_STATUSES[0];

export const getLeadStatusBadgeClass = (status, isDark, leadStatuses = DEFAULT_LEAD_STATUSES) => {
  const meta = getLeadStatusMeta(status, leadStatuses);
  const tone = meta?.tone || "violet";
  const classes = LEAD_TONE_CLASSES[tone] || LEAD_TONE_CLASSES.violet;
  return isDark ? classes.dark : classes.light;
};

export const getCustomerInitials = (name, phone) => {
  const trimmed = name?.trim();
  if (trimmed) {
    const parts = trimmed.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
    }
    return trimmed.slice(0, 2).toUpperCase();
  }
  const digits = String(phone || "").replace(/\D/g, "");
  return digits.slice(-2) || "?";
};

export const formatCrmDuration = (seconds) => {
  if (!seconds) return "0s";
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return mins === 0 ? `${secs}s` : `${mins}dk ${secs}s`;
};

export const formatCrmDateTime = (value) => {
  if (!value) return "-";
  const d = new Date(String(value).replace(" ", "T"));
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleString("tr-TR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatRelativeTime = (value) => {
  if (!value) return "";
  const d = new Date(String(value).replace(" ", "T"));
  if (Number.isNaN(d.getTime())) return value;
  const diffMs = Date.now() - d.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  if (diffMins < 1) return "Az önce";
  if (diffMins < 60) return `${diffMins} dk önce`;
  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) return `${diffHours} sa önce`;
  const diffDays = Math.floor(diffHours / 24);
  if (diffDays < 7) return `${diffDays} gün önce`;
  return formatCrmDateTime(value);
};

export const getAuthorInitials = (name) => {
  const trimmed = (name || "").trim();
  if (!trimmed) return "?";
  const parts = trimmed.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  return trimmed.slice(0, 2).toUpperCase();
};
